export type WeatherIconKind =
  | 'sunny'
  | 'partly-cloudy'
  | 'cloudy'
  | 'drizzle'
  | 'rainy'
  | 'thunderstorm'
  | 'snow'
  | 'fog'
  | 'unknown';

export function mapConditionToIcon(
  conditions: string | null | undefined
): WeatherIconKind {
  const c = (conditions || '').toLowerCase();
  if (!c.trim()) return 'unknown';
  if (c.includes('thunder') || c.includes('storm') || c.includes('lightning'))
    return 'thunderstorm';
  if (
    c.includes('snow') ||
    c.includes('sleet') ||
    c.includes('ice') ||
    c.includes('flurr')
  )
    return 'snow';
  if (c.includes('fog') || c.includes('mist') || c.includes('haze'))
    return 'fog';
  if (c.includes('drizzle') || c.includes('light rain')) return 'drizzle';
  if (c.includes('rain') || c.includes('shower')) return 'rainy';
  if (
    c.includes('partly') ||
    c.includes('few clouds') ||
    c.includes('scattered')
  )
    return 'partly-cloudy';
  if (c.includes('cloud') || c.includes('overcast')) return 'cloudy';
  if (c.includes('clear') || c.includes('sun') || c.includes('fair'))
    return 'sunny';
  return 'unknown';
}
